import type { Components } from "react-markdown";
import ReactMarkdown from "react-markdown";
import rehypeSanitize from "rehype-sanitize";
import remarkGfm from "remark-gfm";
import { cn } from "@/lib/utils";

interface MarkdownContentProps {
  content: string;
  className?: string;
  components?: Partial<Components>;
}

export function MarkdownContent({
  content,
  className,
  components,
}: MarkdownContentProps) {
  return (
    <div
      className={cn(
        "prose dark:prose-invert max-w-none",
        "prose-headings:text-foreground prose-p:text-card-foreground prose-strong:text-foreground",
        "prose-a:text-primary prose-a:no-underline hover:prose-a:underline",
        "prose-td:text-card-foreground prose-th:text-foreground",
        className,
      )}
    >
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeSanitize]}
        components={components}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
